import ProjectGallery from './project-gallery';

export default ProjectGallery;
